export default __webpack_public_path__ + "static/media/tnt-awards.c3cc2a8e.png";